import { Box, Typography } from "@mui/material";
import SectionHeader from "../../../../components/section-header/SectionHeader";
import SectionHeaderActions from "../../../../components/section-header/SectionHeaderActions";
import SectionHeaderSearch from "../../../../components/section-header/SectionHeaderSearch";
import FinanceStatementsDataGrid from "./FinanceStatementsDataGrid";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Optional Icon
import { useRef, useState } from "react";

export default function FinanceStatements() {
  const gridRef = useRef(null);
  const [searchText, setSearchText] = useState("");

  return (
    <Box display="flex" flexDirection="column" gap={2} mt={3} px={1}>
      {/* --- ATTRACTIVE TITLE SECTION --- */}
      <Box 
        sx={{
          p: 2,
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          bgcolor: '#F3F4F6', 
          borderLeft: '4px solid #004D71', 
          borderRadius: '8px',
        }}
      >
        <InfoOutlinedIcon sx={{ color: '#004D71', fontSize: 28 }} />
        <Box>
          {/* <Typography sx={{ fontWeight: 700, color: '#111827', fontSize: '1rem' }}>
            Audited Financial Statements
          </Typography> */}
          <Typography sx={{ color: '#4B5563', fontSize: '0.85rem' }}>
            Audited financial data provided by the portfolio on a quarterly basis.
          </Typography>
        </Box>
      </Box>

      {/* --- ACTIONS HEADER --- */}
      <SectionHeader
        left={
          <SectionHeaderSearch
            searchValue={searchText}
            onSearchChange={setSearchText}
            onFilterClick={() => gridRef.current?.openFiltersPanel()}
            onColumnClick={() => gridRef.current?.openColumnsPanel()}
          />
        }
        right={<SectionHeaderActions onExport={() => gridRef.current?.exportToExcel()} />}
      />

      {/* --- DATA GRID --- */}
      <FinanceStatementsDataGrid
        ref={gridRef}
        searchText={searchText}
      /> 
    </Box>
  );
}